// extracted by mini-css-extract-plugin
export default {"root":"SummarySection_root__gXTtl","collapsedItem":"SummarySection_collapsedItem__P8udx"};